import { render, staticRenderFns } from "./CRUDRole.vue?vue&type=template&id=4ca592a3&scoped=true&"
import script from "./CRUDRole.vue?vue&type=script&lang=js&"
export * from "./CRUDRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca592a3",
  null
  
)

export default component.exports